import React from 'react';
import PropTypes from 'prop-types';

/** An inline svg component. */
const Mastercard = ({
  size = 16,
  height = 14,
  width = 24,
  svgRef,
  title,
  style = {},
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 24 16"
      height={height || size}
      width={width || size}
      ref={svgRef}
      aria-labelledby={title ? title : undefined}
      style={{ pointerEvents: 'none', ...style }}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
    >
      {title ? <title id={title}>{title}</title> : null}

      <path
        id="Fill 1"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.2252 13.7748H8.7002V2.07483H15.1502L15.2252 13.7748Z"
        fill="#FF5F00"
      />
      <path
        id="Fill 2"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.15 7.925C9.15 5.525 10.275 3.425 12 2.075C10.725 1.1 9.15 0.5 7.425 0.5C3.3 0.5 0 3.875 0 7.925C0 11.975 3.3 15.35 7.425 15.35C9.15 15.35 10.725 14.75 12 13.775C10.275 12.425 9.15 10.325 9.15 7.925Z"
        fill="#EB001B"
      />
      <path
        id="Fill 4"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24 7.925C24 11.975 20.7 15.35 16.575 15.35C14.85 15.35 13.275 14.75 12 13.775C13.725 12.425 14.85 10.325 14.85 7.925C14.85 5.525 13.725 3.425 12 2.075C13.275 1.1 14.85 0.5 16.575 0.5C20.7 0.5 24 3.875 24 7.925Z"
        fill="#F79E1B"
      />
    </svg>
  );
};

Mastercard.propTypes = {
  /** Optional class name to apply to `svg` element. */
  className: PropTypes.string,
  /** Height of `svg`. */
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Gets applied to both `height` and `width` of `svg`. */
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Use if you want to get a `ref` to the `svg` element. */
  svgRef: PropTypes.func,
  /** For accessability. Allows icons in buttons etc. to be read by screen readers. */
  title: PropTypes.string,
  /** Width of `svg`. */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export { Mastercard };
